import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'brastrap/common/icon/Icon';
import ProductSummary from '../../promotional/product-summary/ProductSummary';
import Button from '../../common/button/Button';

const STYLE_PREFIX = 'c-autosuggest';

const matchingSuggestedProductTitlesWithSearchTerm = (
  term,
  searchTerm,
  onClickingOnSearchTermSuggestion,
  basePath
) => {
  const { value: suggestedTerm, matched_terms: matchedTerms } = term;
  const matchedTerm = matchedTerms[0];
  const matchIndex = suggestedTerm.indexOf(matchedTerm);
  const beforeMatch = suggestedTerm.slice(0, matchIndex);
  const mismatchIndex = matchedTerm
    .split('')
    .findIndex((letter, index) => letter !== searchTerm[index]);
  const matchedTermString =
    mismatchIndex === -1 ? matchedTerm : matchedTerm.slice(0, mismatchIndex);
  const afterMatch = suggestedTerm.slice(matchIndex + matchedTermString.length);

  return (
    <li
      key={suggestedTerm}
      className={`${STYLE_PREFIX}__suggested-terms-list-item`}
      data-cnstrc-item-section="Search Suggestions"
      data-cnstrc-item-name={suggestedTerm}
    >
      <Button
        onClick={e => {
          e.preventDefault();
          onClickingOnSearchTermSuggestion(suggestedTerm, {
            basePath: basePath,
          });
        }}
        aria-label={`Search for ${suggestedTerm}`}
        label={
          <>
            {beforeMatch}
            <b>{matchedTermString}</b>
            {afterMatch}
          </>
        }
        modifiers={'suggested-search-title'}
      />
    </li>
  );
};

const AutoSuggest = ({
  productSuggestions,
  suggestedSearch,
  locale,
  isDesktop,
  onClose,
  searchTerm,
  onClickingOnSearchTermSuggestion,
  basePath,
}) => {
  const searchField = document.getElementById('c-header__search__input__field');

  const iconDismiss = <Icon icon="dismiss" fillColour={'#000000'} />;

  return (
    <>
      {suggestedSearch?.length > 0 && productSuggestions?.length > 0 && (
        <div
          role="dialog"
          aria-labelledby={`${STYLE_PREFIX}__autosuggest-title`}
          className={`${STYLE_PREFIX}`}
          data-cnstrc-autosuggest
        >
          <div className={`${STYLE_PREFIX}__suggested-terms`}>
            <h2
              className={`${STYLE_PREFIX}__title`}
              id={`${STYLE_PREFIX}__autosuggest-title`}
            >
              Search suggestions
            </h2>
            <div>
              <ul className={`${STYLE_PREFIX}__search-terms-list`}>
                {suggestedSearch?.map(el => {
                  return matchingSuggestedProductTitlesWithSearchTerm(
                    el,
                    searchTerm,
                    onClickingOnSearchTermSuggestion,
                    basePath
                  );
                })}
              </ul>
            </div>
          </div>

          <div className={`${STYLE_PREFIX}__products`}>
            <h2 className={`${STYLE_PREFIX}__title`}>Top picks for you</h2>
            <div>
              <ul className={`${STYLE_PREFIX}__products-list`}>
                {productSuggestions?.map(suggestedProduct => {
                  return (
                    <li
                      className={`${STYLE_PREFIX}__products-list-item`}
                      data-cnstrc-item-section="Products"
                      data-cnstrc-item-name={suggestedProduct.data.styleName}
                      data-cnstrc-item-id={suggestedProduct.data.id}
                    >
                      <ProductSummary
                        colours={[suggestedProduct.data]}
                        displaySwatches={false}
                        isForHomepageOnly
                        disableRating
                        onAddToBag={false}
                        styleCode={suggestedProduct.data.id}
                        styleName={suggestedProduct.data.styleName}
                        displaySaveItemButton={false}
                        currency={locale !== 'en-GB' ? 'USD' : 'GBP'}
                        hideSizeRange
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          {isDesktop && (
            <Button
              modifiers={['modal-dismiss', 'suggested-dismiss']}
              onClick={() => {
                onClose();
              }}
              onBlur={() => {
                searchField.focus();
              }}
              icon={iconDismiss}
              label=""
              ariaLabel="Close suggested products modal"
            />
          )}
        </div>
      )}
    </>
  );
};

export default AutoSuggest;

AutoSuggest.propTypes = {
  productSuggestions: PropTypes.array,
  suggestedSearch: PropTypes.array,
  locale: PropTypes.string,
  isDesktop: PropTypes.bool,
  onClose: PropTypes.func,
  searchTerm: PropTypes.string,
  onClickingOnSearchTermSuggestion: PropTypes.func,
  basePath: PropTypes.string,
};

AutoSuggest.defaultProps = {
  showSuggest: false,
};
